module.exports = __webpack_public_path__ + "img/nz.dc2ef264.jpg";